import React, { ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import { MobAppManage } from '../../lib';

function RouteMobPersonalCenter(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ''}_x7eiky`} path={`${parentPath}/mobile/uk/appmanage`}>
      {
        <MobAppManage weId={`${props.weId || ''}_jx0jn0`} />
      }
    </Route>
  )
}

export default withRouter(RouteMobPersonalCenter);